<script setup lang="ts">
import { useError } from '#imports'

const error = useError()
const adminSidebarStore = useAdminSidebarStore()
const collapsedSidebarMenu = computed(() => adminSidebarStore.isCollapsed)

</script>

<template>
  <Menu />
  <template v-if="error">
    <slot></slot>
  </template>

  <template v-else>
    <client-only>
      <div class="wad4-admin-layout wad4__container" :class="{ 'wad4-admin-layout--collapsed': collapsedSidebarMenu}">
        <admin-menu/>
        <div class="wad4-admin-layout__content">
          <slot name="header"/>
          <slot/>
        </div>
      </div>
    </client-only>
    <Footer />
  </template>
</template>

<style lang="scss">
.wad4-admin-layout {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: $wad4-spacing-3xl;

  &__content {
    width: 100%;
    min-width: 0;
  }

  &--collapsed {
    .wad4-admin-sidebar {
      display: none;
    }
  }
}

.admin-menu {
  position: fixed;
  top: 88px;
  left: 0;
  width: 260px;
  height: calc(100vh - 88px);
  background: white;
  transform: translateX(-100%);
  transition: transform 0.25s ease;
  z-index: 3000;

  &--collapsed {
    transform: translateX(0);
  }

  @media (max-width: $wad4-breakpoint-desktop-max) {
    top: 72px;
    height: calc(100vh - 72px);
  }
}
</style>
